// extracted by mini-css-extract-plugin
export default {"Title":"ProgressLoader_Title__8N9wO","ProgressContainer":"ProgressLoader_ProgressContainer__Nahqd","ProgressTitle":"ProgressLoader_ProgressTitle__0RE0-"};